import React from 'react';

export const Footer = () => {

    return (
        <footer className="footer">
        <p className="footer__copirate">&copy; 2023, Сергей Осокин</p>
        <a className="footer__link footer__link_main" href="./">Главная</a>
        <a className="footer__link footer__link_GH" href="https://vk.com/sergei_osokin" rel="no noreferrer" target="_blank">ВК</a>
      </footer>
    )
}